import type { ComponentProps } from "react";

export default function ShieldDollarIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.67763 12.0834C7.9378 12.5788 8.4573 12.9167 9.05572 12.9167H10.8335C11.754 12.9167 12.5002 12.1705 12.5002 11.2501C12.5002 10.3296 11.754 9.58339 10.8335 9.58339H9.16683C8.24635 9.58339 7.50016 8.8372 7.50016 7.91672C7.50016 6.99625 8.24635 6.25005 9.16683 6.25005H10.9446C11.543 6.25005 12.0625 6.58797 12.3227 7.08339M10.0002 5.00005V6.25005M10.0002 12.9167V14.1667M16.6668 10.0001C16.6668 14.0904 12.2052 17.0654 10.5818 18.0125C10.3973 18.1201 10.3051 18.1739 10.1749 18.2018C10.0739 18.2235 9.92646 18.2235 9.82543 18.2018C9.69524 18.1739 9.603 18.1201 9.4185 18.0125C7.79513 17.0654 3.3335 14.0904 3.3335 10.0001V6.01472C3.3335 5.34846 3.3335 5.01533 3.44246 4.72898C3.53872 4.47601 3.69515 4.25029 3.89821 4.07133C4.12808 3.86875 4.43999 3.75178 5.06383 3.51785L9.532 1.84228C9.70524 1.77732 9.79187 1.74483 9.88098 1.73196C9.96003 1.72053 10.0403 1.72053 10.1193 1.73196C10.2085 1.74483 10.2951 1.77732 10.4683 1.84228L14.9365 3.51785C15.5603 3.75178 15.8722 3.86875 16.1021 4.07133C16.3052 4.25029 16.4616 4.47601 16.5579 4.72898C16.6668 5.01533 16.6668 5.34846 16.6668 6.01472V10.0001Z"
        stroke="rgba(13,48,80,0.8)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
